module.exports = __webpack_public_path__ + "static/media/foto1.b1f9c8df.png";